// contexts/ThemeRouter.js
import KulturKlubTheme from "@/themes/kulturklub/theme"; // vagy ../themes/kulturklub/theme
import PrinterwebshopTheme from "@/themes/printerwebshop/theme";

const THEMES = {
  kulturklub: KulturKlubTheme,
  printerwebshop: PrinterwebshopTheme,
};

export default function ThemeRouter({ children, layoutProps, products }) {
  const theme = process.env.NEXT_PUBLIC_THEME || "kulturklub";
  const ThemeLayout = THEMES[theme] || THEMES.kulturklub;

  return (
    <ThemeLayout {...layoutProps} products={products}>
      {children}
    </ThemeLayout>
  );
}
